// Core
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

// Components
import { AgentsPageComponent } from "./containers/page/agents-page.component";

export const routes: Routes = [
  {
    path: "",
    component: AgentsPageComponent,
    pathMatch: "full"
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AgentsRoutingModule {}
